// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AppConfig } from "../../config/config";
import { SnackMessage, subLevelExamTitles } from "../../config/constant";
import { APIService } from "../../utils/apiService";
import {
  GetExamsRequestState,
  RegisteredExamsPayload,
} from "../../utils/types";
import { enqueueSnackbarMessage } from "../commonSlice/common";

const initialState: GetExamsRequestState = {
  state: "idle",
  stateMessage: null,
  errorMessage: null,
  response: [],
  backgroundProcess: false,
  backgroundProcessMessage: null,
};

export const getRegisteredExams = createAsyncThunk(
  "exams/getRegisteredExams",
  async (contactId: string, { dispatch }) => {
    return new Promise<{ registeredExams: RegisteredExamsPayload[] }>(
      (resolve, reject) => {
        APIService.getInstance()
          .get(
            AppConfig.serviceUrls.getAllRegisteredExams +
              "/" +
              contactId +
              "/exams"
          )
          .then((resp) => {
            if (resp.status == 200) {
              resp.data.forEach(
                (element: { examPaperType: any; examId: any }) => {
                  if (element.examPaperType == null) {
                    var test = element.examId;
                    element.examPaperType =
                      subLevelExamTitles[
                        element.examId as keyof typeof subLevelExamTitles
                      ];
                  }
                }
              );
              resolve({ registeredExams: resp.data });
            } else {
              reject("Something went wrong");
            }
          })
          .catch((error: Error) => {
            dispatch(
              enqueueSnackbarMessage({
                message: SnackMessage.error.registeredExamDetails,
                type: "error",
              })
            );
            reject(error);
          });
      }
    );
  }
);

export const ExamHistorySlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRegisteredExams.pending, (state, action) => {
        state.stateMessage = "Loading Exams";
        state.state = "loading";
        state.backgroundProcess = true;
        state.backgroundProcessMessage = "Fetching Exam Data";
      })
      .addCase(getRegisteredExams.fulfilled, (state, action) => {
        state.response = action.payload.registeredExams;
        state.state = "success";
        state.backgroundProcess = false;
      })
      .addCase(getRegisteredExams.rejected, (state, action) => {
        state.state = "failed";
        state.backgroundProcess = false;
      });
  },
});

export default ExamHistorySlice.reducer;
